import { render } from "./ContractsTableComponent.vue?vue&type=template&id=50d537e1&scoped=true"
import script from "./ContractsTableComponent.vue?vue&type=script&lang=js"
export * from "./ContractsTableComponent.vue?vue&type=script&lang=js"

import "./ContractsTableComponent.vue?vue&type=style&index=0&id=50d537e1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d537e1"]])

export default __exports__